import { Children, cloneElement, useEffect } from 'react';

import { useColorCodePutSetting } from '../../../Common/Queries/settingQueries';

export function ColorSelectorContainer(props) {
  const putConfig = useColorCodePutSetting();

  const { children, setPopOver, userId } = props;
  const child = Children.only(children);

  useEffect(() => {
    if (putConfig?.isSuccess) setPopOver((prev) => ({ ...prev, [userId]: null }));
  }, [putConfig?.isSuccess]);

  return cloneElement(child, {
    updateConfig: putConfig,
  });
}
